export default "__VITE_ASSET__CSrr0Qj3__"